export default "__VITE_ASSET__UA5WVVI5__"